module.exports = __webpack_public_path__ + "static/badge_small-d66b7993f5d4fada854ceb47e4999784.svg";